// src/components/MetricRatio.js
import React from 'react';
import { formatNumber } from '../utils/format';
import definitions from '../definitionPlaceholders.json';
import Tooltip from './Tooltip';

const MetricRatio = ({ selectedCompany, stockSymbol, metricsData }) => {
  const defaultMetrics = {
    'Total Assets': 'N/A',
    'Total Current Assets': 'N/A',
    'Cash and Cash Equivalents': 'N/A',
    'Net Receivables': 'N/A',
    'Inventory': 'N/A',
    'Retained Earnings': 'N/A',
    'Total Equity': 'N/A',
    'Total Liabilities': 'N/A',
    'Total Current Liabilities': 'N/A',
    'Account Payable': 'N/A',
    'Net Debt': 'N/A',
    'Common Stock': 'N/A',
  };

  const definitionKeyMap = {
    'Total Assets': 'totalAssets',
    'Total Current Assets': 'totalCurrentAssets',
    'Cash and Cash Equivalents': 'cashAndCashEquivalents',
    'Net Receivables': 'netReceivables',
    'Inventory': 'inventory',
    'Retained Earnings': 'retainedEarnings',
    'Total Equity': 'totalEquity',
    'Total Liabilities': 'totalLiabilities',
    'Total Current Liabilities': 'totalCurrentLiabilities',
    'Account Payable': 'accountPayable',
    'Net Debt': 'netDebt',
    'Common Stock': 'commonStock',
  };

  const displayMetrics = { ...defaultMetrics, ...(metricsData || {}) };

  return (
    <div className="w-full my-4">
      <div className="card p-5 min-h-[625px]">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-6 bg-balance rounded-full" />
          <h2 className="section-heading">
            Balance Sheet{selectedCompany ? ` | ${selectedCompany}` : ''}{stockSymbol ? ` | ${stockSymbol}` : ''}
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-3 w-full min-w-0">
          {Object.keys(displayMetrics).map((key, index) => {
            const defKey = definitionKeyMap[key];
            const defText = defKey ? definitions[defKey] : null;

            return (
              <div
                key={index}
                className="relative bg-balance-light border border-blue-200 p-4 rounded-lg min-h-[96px] card-hover overflow-x-hidden overflow-y-visible"
              >
                {defText && (
                  <Tooltip content={defText}>
                    <span
                      className="absolute top-2 left-2 text-xs text-gray-500 cursor-help"
                      tabIndex={0}
                      aria-label={`Definition for ${key}`}
                    >
                      ℹ️
                    </span>
                  </Tooltip>
                )}

                <div className="absolute bottom-2 left-2 right-2 text-xs sm:text-sm font-medium text-gray-600 break-words">
                  {key}
                </div>

                <div className="absolute top-5 right-3 left-8 text-sm sm:text-lg font-semibold text-balance-dark text-right break-words">
                  {formatNumber(key, displayMetrics[key], defKey)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MetricRatio;



